import React from "react";
import { Container, Row, Col } from "reactstrap";

import Highlight from "../components/Highlight";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useState } from "react"



export const ProfileComponent = () => {
  //const { user } = useAuth0();
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("")

  const setAxiosTokenInterceptor = async (getAccessTokenSilently) => {
    const accessToken = await getAccessTokenSilently();
    setToken(accessToken)
    //alert(accessToken)
    console.log("token: " + accessToken)
  }
  setAxiosTokenInterceptor(getAccessTokenSilently)
  
  const username = user['https://upload.fairplayftp.io/username']
  
  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={2}>
          <img
            src={user.picture}
            alt="Profile"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
          />
        </Col>
        <Col md>
          { /* <h2>{user.name}</h2>
          <p className="lead text-muted">{user.email}</p> */ }
          <h2>{username}</h2>
        </Col>
      </Row>
      <Row>
        <Highlight>{JSON.stringify(user, null, 2)}</Highlight>
        <Highlight>Token: {token}</Highlight>
      </Row>
    </Container>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
